module.exports = "/_next/static/images/uv-layer-browser-not-supported-3ace45c73439a5f66d0655798af96542.png";